query Suppliers(
  $first: Int
  $after: Cursor
  $filter: SupplierFilter
  $orderBy: [SuppliersOrderBy!]
) {
  suppliers(first: $first, after: $after, filter: $filter, orderBy: $orderBy) {
    nodes {
      id
      __typename
      _urgencyLevel
      _sortName
      vendorNumber
      federalTaxReference
      vatNumber
      _pendingApprovers
      supplierRatingResults {
              id
          countTotal
          starValue
          star1Percent
          star2Percent
          star3Percent
          star4Percent
          star5Percent
      }
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      _isUpdatable
      _isDeletable
      _rowTimestamp
      approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
        nodes {
          id
          requesterName
          requestedDate
          amount1
          currencyIsoCode
          isApprovalTreeViewerAllowed
          iconType {
            iconType
            iconState
          }
          statusType {
            statusType
          }
        }
      }
      supplierAddressesBySupplierId(orderBy: IS_PRIMARY_DESC) {
        nodes {
          id
          _rowTimestamp
          addressLine1
          addressLine2
          cityName
          countryId
          stateRegionId
          postalCode
          telephoneNumber
          emailAddress
          webAddress
          isSendEmailAccount
          isReceiveEmailAccount
          isPrimary
          stateRegion {
            stateRegion
            country {
              country
            }
            stateRegionDescription
          }
          country {
            country
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    # totalCount
  }
}
